import {
	CreateCountAssignmentMutation,
	ReassignCountAssignmentMutation,
	UnassignCountAssignmentMutation
} from "~/gql/mutations/material.generated";
import { GetAssignmentHistoryByItemQuery } from "~/gql/queries/produce/productionHardgoodsInventory.generated";

const hardgoodsAssignmentEndpoints = {
	CreateCountAssignment: {
		invalidatesTags: ["CycleCountAssignments"] as AddTagTypes,
		transformResponse: (res: CreateCountAssignmentMutation) => {
			return res;
		}
	},
	GetAssignmentHistoryByItem: {
		providesTags: ["CycleCountAssignments"] as AddTagTypes,
		transformResponse: (res: GetAssignmentHistoryByItemQuery) => {
			return res;
		}
	},
	ReassignCountAssignment: {
		invalidatesTags: ["CycleCountAssignments"] as AddTagTypes,
		transformResponse: (res: ReassignCountAssignmentMutation) => {
			return res;
		}
	},
	UnassignCountAssignment: {
		invalidatesTags: ["CycleCountAssignments"] as AddTagTypes,
		transformResponse: (res: UnassignCountAssignmentMutation) => {
			return res;
		}
	}
};

export default hardgoodsAssignmentEndpoints;
